import appServices from '@/services/appServices';
import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

export default function useReport(reportId?: string) {
  const reportQuery = useQuery({
    queryKey: ['report', reportId],
    queryFn: () => appServices.reportsApi.getReport(reportId!),
    enabled: !!reportId,
  });
  const invalidate = useCallback(() => {
    if (reportId) {
      //   queryClient.invalidateQueries({ queryKey: ['report', reportId] });
      reportQuery.refetch();
    }
  }, [reportId, reportQuery]);
  return {
    invalidate,
    report: reportQuery.data?.data?.report,
    reportData: reportQuery.data?.data?.data,
    isLoading: reportQuery.isLoading,
    error: reportQuery.error,
    refetch: reportQuery.refetch,
  };
}
